import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { RiCloseLine } from "react-icons/ri";
import styled from "styled-components";
import { UiConstants } from "../../../../data/UiConstants";
import { selectorMapEditorStore } from "../../../../stores/MapEditorStore";
import { Submenu } from "../../../menu/PopupSubMenu";
import { ActionMapViewProvider } from "../editors/ActionMapViewProvider";
const EditorPopupContainer = styled(Submenu).withConfig({
  displayName: "MapEditorWindow__EditorPopupContainer",
  componentId: "sc-96r55h-0"
})(["z-index:", ";position:fixed;right:100px;left:100px;top:70px;bottom:100px;height:unset;"], UiConstants.Z_INDEX_POPUP_SUBMENU + 5);
const CloseButton = styled.div.withConfig({
  displayName: "MapEditorWindow__CloseButton",
  componentId: "sc-96r55h-1"
})(["position:absolute;top:0px;right:0px;background-color:#FFFFFF;text-align:center;height:", ";width:", ";font-size:", ";border-bottom-left-radius:", ";border:1px solid black;border-right:none;border-top:none;&:hover{color:grey;cursor:pointer;}"], UiConstants.SIZE_SLIDE_MENU_CLOSE_ICON, UiConstants.SIZE_SLIDE_MENU_CLOSE_ICON, UiConstants.SIZE_SLIDE_MENU_CLOSE_ICON_FONT, UiConstants.BORDER_RADIUS);
export const MapEditorWindow = observer(({
  selectedMapElements,
  selectElement,
  closePopup,
  shouldShowEmptyAreaTriggers
}) => {
  const elementIds = selectedMapElements.elements.map(element => element.id);
  useEffect(() => {
    selectorMapEditorStore.prepareActionMapViewer(elementIds, shouldShowEmptyAreaTriggers);
  }, [elementIds, shouldShowEmptyAreaTriggers]);
  return /*#__PURE__*/React.createElement(EditorPopupContainer, null, /*#__PURE__*/React.createElement(CloseButton, null, /*#__PURE__*/React.createElement(RiCloseLine, {
    onClick: closePopup
  })), /*#__PURE__*/React.createElement(ActionMapViewProvider, {
    selectedMapElements: selectedMapElements,
    selectElement: selectElement
  }));
});